import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Autocomplete from 'react-autocomplete';
import classnames from 'classnames';
import { Link, Prompt } from 'react-router-dom';
import _ from 'lodash';

import { fetchContacts } from '../../../redux/ducks/contacts';
import Contact from '../../../models/Contact';
import InputFeedback from './InputFeedback';
import './ContactPicker.css';

class ContactPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currValue:
        (props.fetched &&
          props.field.value &&
          props.contactsById[props.field.value] &&
          props.contactsById[props.field.value].name) ||
        '',
    };
  }

  componentDidMount() {
    const { isFetching, fetched, getContacts } = this.props;

    if (!fetched && !isFetching) {
      getContacts();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // We may have needed to load contacts on component load, so we wouldn't have been
    // able to set the contact's name in state for tracking. If it's now fetched, check
    // for various factors (like not overwriting what may already be written) and set it.
    if (
      !prevProps.fetched &&
      this.props.fetched &&
      this.props.field.value &&
      !prevState.currValue
    ) {
      // We now have contacts loaded, so try to update our current value state based on that.
      this.setState({
        currValue: this.props.contactsById[this.props.field.value].name,
      });
    }
  }

  render() {
    const {
      field, form, contacts, fetched, className,
    } = this.props;

    if (!fetched) {
      return null;
    }

    const { name } = field;
    const { touched, errors } = form;
    const error = _.get(touched, name) && _.get(errors, name);

    const classes = classnames('input-group contactPicker field', { error: !!error }, className);

    return (
      <div className={classes}>
        <Prompt
          when
          message={location =>
            (location.pathname.startsWith('/contacts/new')
              ? 'Before creating a new contact, be sure to save any pending changes.\n\nIf you have saved, click OK to continue and you will be returned to the item page after saving your new contact so that you can associate it with this item.'
              : true)
          }
        />
        <div className="control">
          <Autocomplete
            getItemValue={contact => contact.name}
            items={contacts}
            sortItems={(a, b) => a.name > b.name}
            renderItem={(item, isHighlighted) => (
              <div
                key={item.id}
                className="contactPicker-dropdownItem"
                style={{ background: isHighlighted ? 'lightgray' : 'white' }}
              >
                {item.name}
              </div>
            )}
            renderMenu={items => (
              <div className="contactPicker-dropdown">
                {items || <div className="contactPicker-dropdownItem">No Matching Contacts</div>}
                <div className="contactPicker-dropdownItem">
                  <Link to={`/contacts/new/${encodeURIComponent(window.location.pathname)}`}>
                    Add New
                  </Link>
                </div>
              </div>
            )}
            value={this.state.currValue}
            onChange={(e, val) => {
              this.setState({ currValue: val });
            }}
            onSelect={(val, item) => {
              this.setState({ currValue: item.name });
              form.setFieldValue(field.name, item.id);
            }}
            shouldItemRender={
              (item, value) => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
            }
          />
        </div>
        <InputFeedback error={error} />
      </div>
    );
  }
}

ContactPicker.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
  }).isRequired,
  contacts: PropTypes.arrayOf(PropTypes.instanceOf(Contact)),
  contactsById: PropTypes.objectOf(PropTypes.instanceOf(Contact)),
  isFetching: PropTypes.bool.isRequired,
  fetched: PropTypes.oneOfType([PropTypes.bool, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string,
  getContacts: PropTypes.func.isRequired,
};

ContactPicker.defaultProps = {
  contacts: [],
  contactsById: {},
  className: '',
};

function mapStateToProps(state) {
  const {
    contacts: {
      items, itemsById, isFetching, fetched,
    },
  } = state;

  return {
    contacts: items,
    contactsById: itemsById,
    isFetching,
    fetched,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getContacts: () => {
      dispatch(fetchContacts());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactPicker);



// WEBPACK FOOTER //
// ./src/components/common/form/ContactPicker.jsx